import * as React from 'react';

function SvgBellSlashFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M5.164 14H15c-1.5-1-2-5.902-2-7 0-.264-.02-.523-.06-.776L5.164 14zm6.288-10.617A4.988 4.988 0 008.995 2.1a1 1 0 10-1.99 0A5.002 5.002 0 003 7c0 .898-.335 4.342-1.278 6.113l9.73-9.73zM10 15a2 2 0 11-4 0h4zm-9.375.625a.53.53 0 00.75.75l14.75-14.75a.53.53 0 00-.75-.75L.625 15.625z' />
		</svg>
	);
}

export default SvgBellSlashFill;
